export const BREAKPOINTS = {
  xs: 576,
  sm: 768,
  md: 992,
  lg: 1200,
  xl: 1920,
} as const;
export type BreakPoints = keyof typeof BREAKPOINTS;
